import {
  gridAutoColumns,
  GridAutoColumnsProps,
  gridAutoFlow,
  GridAutoFlowProps,
  gridAutoRows,
  GridAutoRowsProps,
  gridColumn,
  gridColumnGap,
  GridColumnGapProps,
  GridColumnProps,
  gridGap,
  GridGapProps,
  gridRow,
  gridRowGap,
  GridRowGapProps,
  GridRowProps,
  gridTemplateColumns,
  gridTemplateRows,
  GridTemplatesColumnsProps,
  GridTemplatesRowsProps,
} from 'styled-system';
import { css } from '~ui-kit/styled-components';
import { applyTransientProps, PrependDollar } from './styled-system-helpers';

export type StyledGridGapProps = PrependDollar<GridGapProps>;

export const styledGridGap = <T extends StyledGridGapProps>(props: T) => applyTransientProps(props, gridGap);

export type StyledGridRowGapProps = PrependDollar<GridRowGapProps>;

export const styledGridRowGap = <T extends StyledGridRowGapProps>(props: T) => applyTransientProps(props, gridRowGap);

export type StyledGridColumnGapProps = PrependDollar<GridColumnGapProps>;

export const styledGridColumnGap = <T extends StyledGridColumnGapProps>(props: T) =>
  applyTransientProps(props, gridColumnGap);

export type StyledGridRowProps = PrependDollar<GridRowProps>;

export const styledGridRow = <T extends StyledGridRowProps>(props: T) => applyTransientProps(props, gridRow);

export type StyledGridColumnProps = PrependDollar<GridColumnProps>;

export const styledGridColumn = <T extends StyledGridColumnProps>(props: T) => applyTransientProps(props, gridColumn);

export type StyledGridAutoFlowProps = PrependDollar<GridAutoFlowProps>;

export const styledGridAutoFlow = <T extends StyledGridAutoFlowProps>(props: T) =>
  applyTransientProps(props, gridAutoFlow);

export type StyledGridAutoRowsProps = PrependDollar<GridAutoRowsProps>;

export const styledGridAutoRows = <T extends StyledGridAutoRowsProps>(props: T) =>
  applyTransientProps(props, gridAutoRows);

export type StyledGridAutoColumnsProps = PrependDollar<GridAutoColumnsProps>;

export const styledGridAutoColumns = <T extends StyledGridAutoColumnsProps>(props: T) =>
  applyTransientProps(props, gridAutoColumns);

export type StyledGridTemplateRowsProps = PrependDollar<GridTemplatesRowsProps>;

export const styledGridTemplateRows = <T extends StyledGridTemplateRowsProps>(props: T) =>
  applyTransientProps(props, gridTemplateRows);

export type StyledGridTemplateColumnsProps = PrependDollar<GridTemplatesColumnsProps>;

export const styledGridTemplateColumns = <T extends StyledGridTemplateColumnsProps>(props: T) =>
  applyTransientProps(props, gridTemplateColumns);

export interface StyledGridLayoutProps
  extends StyledGridGapProps,
    StyledGridRowGapProps,
    StyledGridColumnGapProps,
    StyledGridRowProps,
    StyledGridColumnProps,
    StyledGridAutoFlowProps,
    StyledGridAutoRowsProps,
    StyledGridAutoColumnsProps,
    StyledGridTemplateRowsProps,
    StyledGridTemplateColumnsProps {}

export const styledGridLayout = css<StyledGridLayoutProps>`
  ${styledGridGap}
  ${styledGridRowGap}
  ${styledGridColumnGap}
  ${styledGridRow}
  ${styledGridColumn}
  ${styledGridAutoFlow}
  ${styledGridAutoRows}
  ${styledGridAutoColumns}
  ${styledGridTemplateRows}
  ${styledGridTemplateColumns}
`;
